<template>
<div class="page">
  <m-box class="has-el-form" v-loading="isLoading">
    <el-form inline>
      <el-form-item label="渠道ID">
        <el-select v-model="formData.channel_id" :size="formSize" clearable >
          <!-- <el-option :value="''" label="全部"></el-option> -->
          <el-option v-for="channel in channels" :value="channel.channel_id" :key="channel.channel_id" :label="`${channel.channel_id}（${channel.channel_name}）`"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :size="formSize" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>
  </m-box>
  <m-box title="资源信息">
    <div v-if="detail">
      <p><strong>资源限量配置</strong></p>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane :label="key" :name="key" v-for="(item, key) in detail" :key="key">
          <el-form inline label-width="150px">
            <el-form-item label="红杏ID">
              <el-input :value="item.detail.service_code" readonly :size="formSize" />
            </el-form-item>
            <el-form-item label="赠送会员类型">
              <!-- <el-input :value="vipTyps[item.detail.vip_type]" readonly :size="formSize" /> -->
              <el-input :value="item.detail.vip_type" readonly :size="formSize" />
            </el-form-item>
            <el-form-item label="赠送会员天数">
              <el-input :value="item.detail.days" readonly :size="formSize" />
            </el-form-item>
            <el-form-item label="赠送次数">
              <el-input :value="item.detail.times.join(',')" readonly :size="formSize" />
            </el-form-item>
            <el-form-item label="资源有效期">
              <el-input style="width: 400px" :value="format(item.detail.start_time, 'yyyy年MM月dd日 HH:mm:ss') + '——' + format(item.detail.end_time, 'yyyy年MM月dd日 HH:mm:ss')" readonly :size="formSize" />
            </el-form-item>
            <el-form-item label="支持发放账号">
              <el-input :value="toAccount(item.detail.support_account)" readonly :size="formSize" />
            </el-form-item>
          </el-form>

          <p><strong>资源消耗及限量</strong></p>
          <el-table :data="item.limits" border stripe>
            <el-table-column label="类型" prop="typeName"></el-table-column>
            <el-table-column label="有效期内总消耗/总量">
              <template slot-scope="scope">
                <span>{{scope.row.use.activity}}/{{scope.row.activity === -1 ? '不限量' : scope.row.activity}}</span>
              </template>
            </el-table-column>
            <el-table-column label="当月消耗/单月限量">
              <template slot-scope="scope">
                <span>{{scope.row.use.month}}/{{scope.row.month === -1 ? '不限量' : scope.row.month}}</span>
              </template>
            </el-table-column>
            <el-table-column label="当周消耗/单周限量">
              <template slot-scope="scope">
                <span>{{scope.row.use.week}}/{{scope.row.week === -1 ? '不限量' : scope.row.week}}</span>
              </template>
            </el-table-column>
            <el-table-column label="当日消耗/单日限量">
              <template slot-scope="scope">
                <span>{{scope.row.use.day}}/{{scope.row.day === -1 ? '不限量' : scope.row.day}}</span>
              </template>
            </el-table-column>
          </el-table>

          <p><strong>单账号获得该资源限量</strong></p>
          <el-table :data="item.simple_limits" border stripe>
            <el-table-column label="账号类型" prop="typeName"></el-table-column>
            <el-table-column label="单账号总限量">
              <template slot-scope="scope">
                <span>{{scope.row.activity === -1 ? '不限量' : scope.row.activity}}</span>
              </template>
            </el-table-column>
            <el-table-column label="单月限量">
              <template slot-scope="scope">
                <span >{{scope.row.month === -1 ? '不限量' : scope.row.month}}</span>
              </template>
            </el-table-column>
            <el-table-column label="单周限量">
              <template slot-scope="scope">
                <span >{{scope.row.week === -1 ? '不限量' : scope.row.week}}</span>
              </template>
            </el-table-column>
            <el-table-column label="单日限量">
              <template slot-scope="scope">
                <span >{{scope.row.day === -1 ? '不限量' : scope.row.day}}</span>
              </template>
            </el-table-column>
          </el-table>

        </el-tab-pane>
      </el-tabs>
    </div>
  </m-box>
</div>
</template>
<script>
import channelApi from '../../api/channel'
import { format } from '../../utils/time'

export default {
  data () {
    return {
      formSize:  'small',
      formData: {
        channel_id: '',
        inf_type: 'hlwmp'
      },
      vipTyps: {
        0: 'hvip',
        38: 'svip'
      },
      isLoading: false,
      title: '资源限量信息',
      visible: false,
      orderInfo: null,
      activeName: ''
    }
  },
  computed: {
    channels () {
      return this.$store.state.user.channelInfo || []
    },
    // orderInfo () {
    //   // let data = `{"msg": "ok", "data": {"consumed": {"vip_3": {"limit_res_total": {"week": 0, "month": 0, "day": 0, "activity": 0}, "limit_res_wx": {"week": 0, "month": 0, "day": 0, "activity": 0}, "limit_res_qq": {"week": 0, "month": 0, "day": 0, "activity": 0}}}, "orig": {"vip_3": {"limit_res_wx": {"week": -1, "activity": 425000, "day": -1, "month": -1}, "service_code": "hlw_wxkankan_day3_20180925", "limit_user_phone": {"week": -1, "activity": 1, "day": -1, "month": -1}, "start_time": "2018-08-22 00:00:00", "limit_user_qq": {"week": -1, "activity": 1, "day": -1, "month": -1}, "vip_type": 0, "days": 3, "times": [1], "end_time": "2019-08-31 23:59:59", "limit_user_wx": {"week": -1, "activity": 1, "day": -1, "month": -1}, "limit_res_total": {"week": -1, "activity": 450000, "day": -1, "month": -1}, "limit_res_qq": {"week": -1, "activity": 25000, "day": -1, "month": -1}}}}, "ret": 0}`
    //   // data = JSON.parse(data).data
    //   return data
    // },
    detail () {
      if (!this.orderInfo) return null
      const data = {}
      const orig = this.orderInfo.orig
      const consumed = this.orderInfo.consumed
      for (let key in orig) {
        data[key] = {
          detail: orig[key],
          limits: [
            { type: 'limit_res_total', typeName: '资源总量', ...orig[key].limit_res_total, use: consumed[key].limit_res_total }
          ],
          simple_limits: [
            { type: 'limit_user_qq', typeName: 'QQ单账号', ...orig[key].limit_user_qq, use: null },
            { type: 'limit_user_wx', typeName: '微信单账号', ...orig[key].limit_user_wx, use: null }
          ]
        }

        if (consumed[key].limit_res_qq) {
          data[key].limits.push({ type: 'limit_res_qq', typeName: 'QQ账号', ...orig[key].limit_res_qq, use: consumed[key].limit_res_qq })
        }
        if (consumed[key].limit_res_wx) {
          data[key].limits.push({ type: 'limit_res_wx', typeName: '微信账号', ...orig[key].limit_res_wx, use: consumed[key].limit_res_wx })
        }

        if (orig[key].limit_user_phone) {
          data[key].simple_limits.push({ type: 'limit_user_phone', typeName: '手机单账号', ...orig[key].limit_user_phone, use: null })
        }
      }

      return data
    }
  },
  watch: {
    show (val) {
      if (val) this.handleInit()
      this.visible = val
    },
    visible (val) {
      this.$emit('update:show', val)
    },
    channels() {
      this.formData.channel_id = this.channels[0].channel_id;
    }
  },
  methods: {
    format,
    toAccount (accounts = []) {
      return accounts.map(e => {
        switch (e) {
          case 'qq':
            return 'QQ'
          case 'wx':
            return '微信'
          case 'phone':
            return '手机号'
        }
      }).join('/')
    },
    handleQuery () {
      if (!this.formData.channel_id) return this.$message.warning('渠道ID不能为空')
      this.isLoading = true
      channelApi.topup.getOrderInfo(this.formData).then(res => {
        console.log(res)
        if (res.ret === 0 && res.data) {
          this.orderInfo = res.data
          this.activeName = Object.keys(res.data.orig)[0]
        }
        this.isLoading = false
      }).catch(err => {
        console.log(err)
        this.$message.error(err.message)
        this.orderInfo = null
        this.isLoading = false
      })
    }
  },
  created () {
    if (this.channels.length > 0) {
      this.formData.channel_id = this.channels[0].channel_id;
    }
    // this.handleInit()
    this.visible = this.show
  }
}
</script>
